<template>
  <div>
    <b-card title="Görsel">
      <b-img
        v-if="itemData.image"
        :src="imageUrl + '/media/mod_leads/' + itemData.image"
        thumbnail
        center
      />
      <div class="text-center mt-1">
        <b-button
          variant="primary"
          :disabled="!itemData.lead_type"
          @click="setModal('mod_leads')"
        >
          <FeatherIcon icon="UploadIcon" />
          Görsel Yükle
        </b-button>
      </div>
    </b-card>
    <cropper-image
      v-if="cropperSettings.type"
      :modal-status="cropperSettings.modalStatus"
      :close-modal="closeModal"
      :file-name="cropperSettings.fileName"
      :folder="cropperSettings.folder"
      :ratio="cropperSettings.ratio"
      :width-size="cropperSettings.widthSize"
      component="mod_leads"
      :params="cropperSettings.type"
      :item-id="itemData.id"
      @uploadImage="setUploadImage"
    />
  </div>
</template>

<script>
import { BButton, BCard, BImg } from 'bootstrap-vue'
import CropperImage from '@/layouts/components/common/CropperImage.vue'

export default {
  name: 'ModLeadsImageCard',
  components: {
    CropperImage, BCard, BButton, BImg,
  },
  data() {
    return {
      imageUrl: this.$store.state.app.baseURL,
      cropperSettings: {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        widthSize: null,
        type: null,
      },
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['modLeads/dataItem']
    },
    setResolution() {
      let resolution = null
      let width = null
      if (this.itemData.lead_type === '1') {
        resolution = null
        width = 1860
      }
      if (this.itemData.lead_type === '2') {
        resolution = null
        width = 1860
      }
      if (this.itemData.lead_type === '3') {
        resolution = 93 / 93
        width = 93
      }
      return { resolution, width }
    },
  },
  methods: {
    setModal(type) {
      if (type === 'mod_leads') {
        this.cropperSettings = {
          modalStatus: true,
          fileName: 'mod-leads-image.jpg',
          folder: 'mod_leads',
          ratio: this.setResolution.resolution,
          widthSize: this.setResolution.width,
          type: 'mod_leads',
        }
      }
    },
    closeModal() {
      this.cropperSettings = {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        widthSize: null,
        type: null,
      }
    },
    setUploadImage(item) {
      if (this.cropperSettings.type === 'mod_leads') {
        this.itemData.image = item.filename
        this.itemData.thumb = item.thumb
        this.itemData.image_webp = item.filename_webp
        this.itemData.thumb_webp = item.thumb_webp
        this.itemData.mediaData = item
      }
      this.cropperSettings.modalStatus = false
    },
  },
}
</script>
